var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 11.4686L2.36569 8.43432C2.05327 8.1219 1.54673 8.1219 1.23431 8.43432C0.921895 8.74673 0.921895 9.25327 1.23431 9.56569L4.83431 13.1657C5.14673 13.4781 5.65327 13.4781 5.96569 13.1657L14.7657 4.36569C15.0781 4.05327 15.0781 3.54673 14.7657 3.23431C14.4533 2.9219 13.9467 2.9219 13.6343 3.23431L5.4 11.4686Z",
    fill: "#31DE91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic-check.02d6037a48f6995d0c0158b8359f67ed.svg";
export { ForwardRef as ReactComponent };